import React, { Component } from 'react';

import { shape } from 'prop-types';
import { Spin } from 'antd';
import './AuthenticationCompleteScreen.scss';
import { inject, observer, disposeOnUnmount } from 'mobx-react';
import { reaction } from 'mobx';

class AuthenticationCompleteScreen extends Component {
  componentDidMount() {
    const { store } = this.props;
    const search = window.location.search.substr(1);

    const arrSearch = search.split('&');

    arrSearch.forEach(param => {
      const arrParam = param.split('=');

      if (arrParam[0] === 'source') {
        store.setParameterId(arrParam[1]);
      }
    });

    store.loadData();

    disposeOnUnmount(this, [
      reaction(
        () => {
          return store.threeDSecure.status;
        },
        status => {
          if (!store.notified) {
            if (status === 'consumed' || status === 'failed') {
              store.setNotified(true);
              if (store.threeDSecure.returnUrl === 'paymongojs://three_d_secure/return_url') {
                if (window.top !== window.parent) {
                  window.parent.postMessage('3DS-authentication-complete', '*');
                } else {
                  window.top.postMessage('3DS-authentication-complete', '*');
                }
              } else {
                window.location.href = store.threeDSecure.returnUrl;
              }
            } else if (status === 'pending' || status === 'chargeable') {
              setTimeout(() => {
                store.loadData();
              }, 2000);
            }
          }
        }
      )
    ]);
  }

  render() {
    const { store } = this.props;

    let message = '';

    if (store.threeDSecure.status === 'consumed') {
      message = 'Authentication Complete';
    } else if (store.threeDSecure.status === 'failed') {
      message = 'Authentication failed or cancelled.';
    }

    return (
      <div className="AuthenticationCompleteScreen">
        {store.loading ||
        store.threeDSecure.status === 'pending' ||
        store.threeDSecure.status === 'chargeable' ? (
          <div className="Container">
            <Spin />
            <p style={{ marginTop: '1rem' }}>Verifying 3D Secure Authentication</p>
          </div>
        ) : (
          <div className="Container">
            <p className="Header">{message}</p>
            <p>You may close this window.</p>
          </div>
        )}
      </div>
    );
  }
}

AuthenticationCompleteScreen.propTypes = {
  store: shape({})
};

AuthenticationCompleteScreen.defaultProps = {
  store: {}
};

export default inject(stores => {
  return {
    store: stores.store.threeDSecure
  };
})(observer(AuthenticationCompleteScreen));
